import styled from "@emotion/styled";

export const MetabotRoot = styled.main`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  background-color: var(--mb-color-bg-white);
`;
